import axios from 'axios';

const instance = axios.create({});

export default {
  // export all axios default properties
  ...instance,
};
